import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import bgImgStories from "../../Assets/stories/stories-section-bg.png";
import './style.css';
import MainHeading from '../../GlobalComponents/Utils/mainHeading';
import alJazeeraLogo from '../../Assets/logos/aljazeera.png';
import { MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
import { useTranslation } from 'react-i18next';
import { Pagination, Autoplay } from 'swiper/modules';

export default function SwiperSlider() {
    const { t, i18n } = useTranslation();
    const desktopSwiperRef = useRef(null);
    const mobileRef = useRef(null);

    const handleNext = () => {
        if (desktopSwiperRef.current) {
            desktopSwiperRef.current.swiper.slideNext();
        }
    };

    const handlePrev = () => {
        if (desktopSwiperRef.current) {
            desktopSwiperRef.current.swiper.slidePrev();
        }
    };

    const translatedItems = t('storiesData.items', { returnObjects: true });

    const images = [
        alJazeeraLogo,
        alJazeeraLogo,
        alJazeeraLogo,
        alJazeeraLogo,
        alJazeeraLogo
    ];

    const mappedStories = translatedItems.map((item, index) => ({
        ...item,
        img: images[index] || alJazeeraLogo
    }));

    return (
        <>
            <div
                style={{ backgroundImage: `url(${bgImgStories})` }}
                className='mySlider smile'
            >
                <MainHeading
                    width={'95%'}
                    gap={'10px'}
                    flexDirection={'row'}
                    align={'center'}
                    margin={"0 0 40px 0"}
                    content1={t("storiesData.firstpart")}
                    content2={t("storiesData.secondpart")}
                />

                <div onClick={handlePrev} className="swiper-button-prev-cust"><MdArrowBackIos /></div>

                <Swiper
                    key={i18n.language} // ✅ force re-render on language change
                    ref={desktopSwiperRef}
                    spaceBetween={5}
                    slidesPerView={1.6}
                    initialSlide={1}
                    loop={true}
                    centeredSlides={true}
                    pagination={{ clickable: true }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    modules={[Pagination, Autoplay]}
                    className="mySwiper"
                >
                    {mappedStories.map((item, index) => (
                        <SwiperSlide key={index} className='innerSliderContent'>
                            <img src={item.img} alt='logo' />
                            <p>{item.post}</p>
                            <div>
                                <h3>{item.name}</h3>
                                <h4>{item.position}</h4>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div onClick={handleNext} className="swiper-button-next-cust"><MdArrowForwardIos /></div>
            </div>

            <div
                style={{ backgroundImage: `url(${bgImgStories})` }}
                className='mobile-view-mySlider'
            >
                <MainHeading
                    width={'95%'}
                    gap={'10px'}
                    flexDirection={'row'}
                    align={'center'}
                    content1={t("storiesData.firstpart")}
                    content2={t("storiesData.secondpart")}
                />

                <Swiper
                    key={i18n.language} // ✅ force re-render on language change
                    ref={mobileRef}
                    spaceBetween={5}
                    slidesPerView={1.2}
                    initialSlide={1}
                    loop={true}
                    centeredSlides={true}
                    pagination={{ clickable: true }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    modules={[Pagination, Autoplay]}
                    className="mySwiper"
                >
                    {mappedStories.map((item, index) => (
                        <SwiperSlide key={index} className='innerSliderContent'>
                            <img src={item.img} alt='logo' />
                            <p>{item.post}</p>
                            <div>
                                <h3>{item.name}</h3>
                                <h4>{item.position}</h4>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </>
    );
}
